import styles from './FbGroups.module.scss'
import { fbGroups } from '../../../const/benefits'
import { LinkList } from '../../UI/Lists/LinkList/LinkList'

export const FbGroups = (): JSX.Element => (
  <section className={styles.Container}>
    <LinkList links={fbGroups} />
  </section>
)
